module.exports = __webpack_public_path__ + "static/media/mooveez-vice-nez-film-i-kurz.c2f446a5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/download/mooveez-vice-nez-film-i-kurz.pdf
// module id = 124
// module chunks = 0